<label>{{'workforceCutover.start'|translate}}<input type="date" [ngModel]="planningDate()" (ngModelChange)="setPlanningDate($event)"></label>
<label>{{'workforceCutover.publishWeeks'|translate}}<select [(ngModel)]="publishWeeks" (ngModelChange)="review.set(false)">@for(w of [1,2,3,4];track w){<option [ngValue]="w">{{w}}</option>}</select></label>
@if(error()){<p role="alert">{{'workforceCutover.failed'|translate}}</p>}
<ion-modal [isOpen]="!!editor()" (didDismiss)="editor.set(null)" class="stack-modal">
  <ng-template><app-modal-shell [dismissLabel]="'general.close' | translate" (dismiss)="editor.set(null)">
    <h2 modalTitle>{{ 'nav-item.workforce.shifts' | translate }}</h2>
    @if (editor(); as e) {<app-workforce-planning-panel [employee]="e.employee" [selectedDate]="e.date" [shift]="e.shift" (changed)="saved()"/>}
  </app-modal-shell></ng-template>
</ion-modal>
<ion-modal [isOpen]="!!actualDetail()" (didDismiss)="actualDetail.set(null)" class="stack-modal"><ng-template>
 <app-modal-shell [dismissLabel]="'general.close'|translate" (dismiss)="actualDetail.set(null)">
  <h2 modalTitle>{{'employeeV2.milestone.actual'|translate}}</h2>
  @if(actualDetail();as actual){
   @if(actualDetailEntries().length > 1){<div class="shift-actual-sessions">
    @for(entry of actualDetailEntries();track entry.id){<button type="button" (click)="openActual(entry)" [attr.aria-pressed]="entry.id === actual.id">{{siteName(entry.siteId)}} · {{entry.start}} – {{entry.end}} · {{entry.minutes|employeeDuration:'compact'}}</button>}
   </div>}
   <app-time-entry [title]="siteName(actual.siteId)" [subtitle]="actualProjectName() !== '—' ? actualProjectName() : ''" [duration]="actual.minutes|employeeDuration:'compact'" [time]="actual.start + ' – ' + actual.end" [status]="actual.statusLabel|translate" [tone]="actual.statusLabel === 'employeeV2.milestone.actualReviewed' ? 'success' : 'warning'" />
   <dl class="shift-actual-details">
   <div><dt>{{'users.workspace.schedule.detail.labels.day'|translate}}</dt><dd>{{actual.date|date:'d.M.yyyy'}}</dd></div>
   <div><dt>{{'workforceV2.worker'|translate}}</dt><dd>{{name(actual.workerId)}}</dd></div>
   @if(actual.projectId){<div><dt>{{'workforceV2.project'|translate}}</dt><dd>{{actualProjectName()}}</dd></div>}
   <div><dt>{{'users.workspace.schedule.detail.labels.notes'|translate}}</dt><dd>{{actual.note}}</dd></div>
  </dl>}
 </app-modal-shell>
</ng-template></ion-modal>
@if(review()){
  <section>
    <h2>{{'workforceCutover.publishPeriod'|translate}}</h2>
    @for(r of pendingRows();track r.id){
      <p>{{name(r.firestore_user_id)}} · {{r.shift_date}} · {{r.published?.start_time || '—'}}–{{r.published?.end_time || '—'}} → {{r.cancelled ? ('workforceCutover.cancelShift'|translate) : r.start_time+'–'+r.end_time}}</p>
    }
    <button type="button" [disabled]="busy()" (click)="publish()">{{'shift.actions.publishChanges'|translate}}</button>
    <button type="button" (click)="review.set(false)">{{'workforceCutover.close'|translate}}</button>
  </section>
}
@if ({
  items: items$ | async
}; as vm) {
  <section class="shift-workspace">
    <section class="shift-workspace__controls">
      <div class="shift-workspace__filters">
        @if (roleS() !== 'worker') {
          <label class="shift-workspace__select">
            <app-select-popover [value]="filterTeam()[0]?.guid ?? 'all'"
              (change)="onTeamFilter($any($event.target).value)">
              <ion-select-option value="all">{{ 'shift.team' | translate }}</ion-select-option>
              @for (team of teams$ | async; track team.guid) {
                <ion-select-option [value]="team.guid">{{ team.name }}</ion-select-option>
              }
            </app-select-popover>
          </label>

          <label class="shift-workspace__select">
            <app-select-popover [value]="filterArea()[0]?.guid ?? 'all'"
              (change)="onAreaFilter($any($event.target).value)">
              <ion-select-option value="all">{{ 'shift.area' | translate }}</ion-select-option>
              @for (area of areas$ | async; track area.guid) {
                <ion-select-option [value]="area.guid">{{ area.name }}</ion-select-option>
              }
            </app-select-popover>
          </label>
        }
      </div>

      <div class="shift-workspace__toolbar">
        <div class="shift-workspace__nav-group"
          role="group"
          [attr.aria-label]="'shift.navigation.label' | translate">
          <button class="shift-workspace__nav-button"
            type="button"
            (click)="previousWeek()"
            [attr.aria-label]="'shift.navigation.previous' | translate">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </button>

          <button class="shift-workspace__nav-current"
            type="button"
            (click)="goToCurrentWeek()">
            <span>{{ 'schedule.week' | translate }} {{ weekLabel() }}</span>
            <strong>{{ yearLabel() }}</strong>
          </button>

          <button class="shift-workspace__nav-button"
            type="button"
            (click)="nextWeek()"
            [attr.aria-label]="'shift.navigation.next' | translate">
            <ion-icon name="chevron-forward-outline"></ion-icon>
          </button>
        </div>

        @if (hasPendingChanges()) {
          <button class="shift-workspace__publish"
            type="button"
            (click)="openPublishReview()">
            <ion-icon name="send-outline"></ion-icon>
            <span>{{ 'shift.actions.publishChanges' | translate }}</span>
          </button>
        }
      </div>
    </section>

    @if (vm.items?.length > 0) {
      <section class="shift-workspace__content">
        <div class="shift-table-wrapper">
          <table class="shift-table">
            <thead>
              <tr class="shift-table__header-row">
                <th class="shift-table__header-cell shift-table__header-cell--person">
                  {{ 'shift.person' | translate }}
                </th>
                @for (day of days(); track day.date) {
                  <th class="shift-table__header-cell shift-table__header-cell--day"
                    [class.shift-table__header-cell--weekend]="day.isWeekend"
                    [class.shift-table__header-cell--period-start]="day.isPeriodStart"
                    [class.shift-table__header-cell--period-end]="day.isPeriodEnd">
                    <div class="shift-table__day-header">
                      <strong>{{ day.date | date:'d.M.' }}</strong>
                      @if (day.isPeriodEnd) {
                        <ion-icon name="information-circle-outline"
                          [attr.title]="'users.levelingPeriodChanges' | translate"></ion-icon>
                      }
                    </div>
                  </th>
                }
              </tr>
            </thead>

            <tbody>
              @for (item of vm.items; track item.guid) {
                <tr class="shift-table__row">
                  <td class="shift-table__identity-cell">
                    <button class="shift-table__user-button"
                      type="button"
                      (click)="onUser(item)">
                      <strong>{{ item.name }}</strong>
                      <div class="shift-table__user-meta">
                        @if (item.teams) {
                          <span class="shift-table__user-chip">{{ item.teams }}</span>
                        }
                        @if (item.areas) {
                          <span class="shift-table__user-chip">{{ item.areas }}</span>
                        }
                      </div>
                    </button>
                  </td>

                  @for (day of days(); track day.date) {
                    @let schedule = getItem(day.dateString, item.guid, item.schedules);
                    @let actual = actualFor(day.date,item.guid);
                    <td class="shift-table__schedule-cell"
                      [class.shift-table__schedule-cell--weekend]="day.isWeekend"
                      [class.shift-table__schedule-cell--period-start]="day.isPeriodStart"
                      [class.shift-table__schedule-cell--period-end]="day.isPeriodEnd">
                      <div class="shift-table__day-entry">
                      @if(schedule.hasPlanned || !actual.length || schedule.absence){<button class="shift-table__schedule-button"
                        type="button"
                        [class.shift-table__schedule-button--absence]="schedule.absence"
                        [class.shift-table__schedule-button--published]="schedule.timeStatus === 'published'"
                        [class.shift-table__schedule-button--draft]="schedule.timeStatus === 'draft'"
                        [class.shift-table__schedule-button--full-hours]="item.fullHours"
                        [class.shift-table__schedule-button--selected]="isCellSelected(day.date, item.guid)"
                        [attr.data-tooltip]="getShiftTooltip(schedule, item)"
                        (click)="onItem(day.date, item, item.schedules)">
                        @if (schedule.hours) {
                      <circle-progress [animation]="false"
                        [percent]="schedule.percentage"
                        [radius]="20"
                        [outerStrokeWidth]="2"
                        [innerStrokeWidth]="0"
                        [showSubtitle]="false"
                        [title]="schedule.hours.hours + ',' + schedule.hours.minutes"
                        [titleFontSize]="'0.6em'"
                        [titleColor]="'var(--ion-color-light-contrast)'"
                        [unitsColor]="'var(--ion-color-light-contrast)'"
                        [units]="'h'">
                      </circle-progress>
                    } @else {
                      <span class="shift-table__empty-slot">{{ (schedule.hasPlanned ? 'employeeV2.milestone.planned' : schedule.absence ? 'workforceCutover.absent' : 'shift.emptyCell') | translate }}</span>
                    }
                    </button>}
                    @if(actual.length){<button type="button" class="shift-table__actual"
                      [class.shift-table__schedule-button]="!schedule.hasPlanned && !schedule.absence"
                      [class.shift-table__actual--comparison]="schedule.hasPlanned || schedule.absence"
                      [attr.aria-label]="('employeeV2.milestone.actual'|translate) + ' ' + actualDuration(actual) + (!schedule.hasPublished ? ' · ' + ('employeeV2.milestone.noPlannedShift'|translate) : '')"
                      [attr.title]="('employeeV2.milestone.actual'|translate) + (!schedule.hasPublished ? ' · ' + ('employeeV2.milestone.noPlannedShift'|translate) : '')"
                      (click)="openActual(actual[0])">
                      @if(schedule.hasPlanned || schedule.absence){<span>{{'employeeV2.milestone.actual'|translate}} </span>}
                      <span class="shift-table__actual-duration">{{actualDuration(actual)}}</span>
                    </button>}
                    @if(!schedule.hasPlanned && actual.length){<button type="button" class="shift-table__add-shift" [attr.aria-label]="'users.workspace.schedule.actions.addShift'|translate" [attr.title]="'users.workspace.schedule.actions.addShift'|translate" (click)="onItem(day.date,item,item.schedules)">+</button>}
                    </div>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>
    } @else {
      <section class="shift-workspace__empty">
        <app-no-results></app-no-results>
      </section>
    }
  </section>
}
<details>
 <summary>{{'workforceCutover.policy'|translate}}</summary>
 <label>{{'workforceCutover.weeklyMinutes'|translate}}<input type="number" [(ngModel)]="policyWeekly" min="1" max="10080"></label>
 <label>{{'workforceCutover.periodStart'|translate}}<input type="date" [(ngModel)]="policyStart"></label>
 <label>{{'workforceCutover.periodWeeks'|translate}}<input type="number" [(ngModel)]="policyWeeks" min="1" max="52"></label>
 <button type="button" [disabled]="options().role!=='ADMIN'" (click)="savePolicy()">{{'workforceCutover.save'|translate}}</button>
 @if(totals()?.policy){
   @for(e of totals().employees;track e.employee){
     <h3>{{name(e.employee)}}</h3>
     @for(w of e.weeks;track w.start){<p>{{w.start}} · {{w.minutes}} / {{w.expected}} min · {{'workforceCutover.overtime'|translate}} {{w.overtime}} min</p>}
     @for(p of e.periods;track p.start){<p>{{p.start}}–{{p.end}} · {{p.minutes}} / {{p.expected}} min</p>}
   }
 }@else{<p>{{'workforceCutover.policyMissing'|translate}}</p>}
</details>
